"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExperimentOptIn = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importStar(require("react"));
var analytics_subjects_1 = require("../../../domains/billing/analytics-subjects");
var feature_1 = require("../feature");
var internal_tracker_1 = require("../internal-tracker");
var component_tooling_1 = require("./component-tooling");
function getStoredState(storageKey) {
    var value = localStorage.getItem(storageKey);
    if (!value) {
        return null;
    }
    if (value === 'true') {
        return true;
    }
    if (value === 'false') {
        return false;
    }
    return value;
}
function ExperimentOptIn(_a) {
    var _b, _c, _d, _e;
    var featureName = _a.featureName, optedInFeatureValue = _a.optedInFeatureValue, optedOutFeatureValue = _a.optedOutFeatureValue;
    var _f = (0, component_tooling_1.useComponents)(), CTAButton = _f.CTAButton, P = _f.P, ButtonGroup = _f.ButtonGroup, Icon = _f.Icon, Card = _f.Card, TextLink = _f.TextLink, Margin = _f.Margin, Callout = _f.Callout;
    var storageKey = "experiment-optin-".concat(featureName);
    var _g = (0, feature_1.useFeatureContext)(), features = _g.features, setFeatures = _g.setFeatures;
    var _h = __read((0, react_1.useState)(false), 2), isOptedIn = _h[0], setIsOptedIn = _h[1];
    var _j = __read((0, react_1.useState)(false), 2), feedbackGiven = _j[0], setFeedbackGiven = _j[1];
    (0, react_1.useEffect)(function () {
        var _a;
        if (!!features) {
            var storedState = getStoredState(storageKey);
            // This should fire just once, when the features are ready and the user
            // already has stored state from interacting with the component
            if (storedState !== null && storedState !== features[featureName]) {
                setFeatures((_a = {},
                    _a[featureName] = storedState,
                    _a));
            }
            setIsOptedIn(features[featureName] === optedInFeatureValue);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [features]);
    if (!features) {
        return null;
    }
    var toggleFeature = function (e) {
        var _a;
        e.preventDefault();
        var newFeatureValue = features[featureName] === optedInFeatureValue
            ? optedOutFeatureValue
            : optedInFeatureValue;
        setFeatures((_a = {},
            _a[featureName] = newFeatureValue,
            _a));
        localStorage.setItem(storageKey, newFeatureValue.toString());
    };
    var handleFeedback = function () {
        setFeedbackGiven(true);
    };
    return (react_1.default.createElement(Card, null,
        !isOptedIn ? (react_1.default.createElement(P, null, "There\u2019s a new design for this page available, want to try it out?")) : (react_1.default.createElement(P, null,
            "You\u2019re viewing the new design for this page, let us know what you think or",
            ' ',
            react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.EXPERIMENT_OPT_OUT_BUTTON, properties: (_b = {}, _b[internal_tracker_1.INTERNAL_EVENT_FLAG] = true, _b) },
                react_1.default.createElement(TextLink, { onClick: toggleFeature }, "switch back to the old version")),
            ".")),
        react_1.default.createElement(ButtonGroup, null, !isOptedIn && (react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.EXPERIMENT_OPT_IN_BUTTON, properties: (_c = {}, _c[internal_tracker_1.INTERNAL_EVENT_FLAG] = true, _c) },
            react_1.default.createElement(CTAButton, { variant: "secondary", onClick: toggleFeature }, "See the new design")))),
        isOptedIn && !feedbackGiven && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(ButtonGroup, null,
                react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.EXPERIMENT_FEEDBACK_LIKE_BUTTON, properties: (_d = {}, _d[internal_tracker_1.INTERNAL_EVENT_FLAG] = true, _d) },
                    react_1.default.createElement(CTAButton, { variant: "primary", onClick: handleFeedback, "aria-description": "I like the new version of this page" },
                        react_1.default.createElement(Icon, { style: { verticalAlign: 'baseline' }, name: "thumbs-up" }),
                        "I like it")),
                react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.EXPERIMENT_FEEDBACK_DISLIKE_BUTTON, properties: (_e = {}, _e[internal_tracker_1.INTERNAL_EVENT_FLAG] = true, _e) },
                    react_1.default.createElement(CTAButton, { variant: "destructive", onClick: handleFeedback, "aria-description": "I don't like the new version of this page" },
                        react_1.default.createElement(Icon, { name: "thumbs-down" }),
                        "I don't like it"))))),
        isOptedIn && feedbackGiven && (react_1.default.createElement(Margin, { top: 4 },
            react_1.default.createElement(Callout, { variant: "success" }, "Thanks for your feedback")))));
}
exports.ExperimentOptIn = ExperimentOptIn;
